import React from "react";
import { useI18n } from "@/i18n/I18nContext";

function FormDot({ r }) {
  const color =
    r === "W" ? "bg-volt text-black" : r === "D" ? "bg-white/15 text-white" : "bg-[#FF3B30] text-white";
  return (
    <span className={`inline-flex items-center justify-center w-5 h-5 text-[10px] font-bold ${color}`}>
      {r}
    </span>
  );
}

export default function StandingsTable({ rows, testId = "standings-table" }) {
  const { t } = useI18n();
  return (
    <div data-testid={testId} className="border border-white/10 overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-white/5 border-b border-white/10">
            <th className="text-left px-3 py-3 text-xs uppercase tracking-[0.18em] text-white/50 font-medium w-12">#</th>
            <th className="text-left px-3 py-3 text-xs uppercase tracking-[0.18em] text-white/50 font-medium">{t("table.club")}</th>
            <th className="text-center px-2 py-3 text-xs uppercase tracking-[0.18em] text-white/50 font-medium">{t("table.played")}</th>
            <th className="text-center px-2 py-3 text-xs uppercase tracking-[0.18em] text-white/50 font-medium">{t("table.won")}</th>
            <th className="text-center px-2 py-3 text-xs uppercase tracking-[0.18em] text-white/50 font-medium">{t("table.drawn")}</th>
            <th className="text-center px-2 py-3 text-xs uppercase tracking-[0.18em] text-white/50 font-medium">{t("table.lost")}</th>
            <th className="text-center px-2 py-3 text-xs uppercase tracking-[0.18em] text-white/50 font-medium hidden md:table-cell">{t("table.gf")}</th>
            <th className="text-center px-2 py-3 text-xs uppercase tracking-[0.18em] text-white/50 font-medium hidden md:table-cell">{t("table.ga")}</th>
            <th className="text-center px-3 py-3 text-xs uppercase tracking-[0.18em] text-volt font-medium">{t("table.points")}</th>
            <th className="text-center px-3 py-3 text-xs uppercase tracking-[0.18em] text-white/50 font-medium hidden lg:table-cell">{t("table.form")}</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr
              key={row.team.id}
              data-testid={`standings-row-${row.team.id}`}
              className="border-b border-white/5 hover:bg-white/[0.03] transition-colors"
            >
              <td className="px-3 py-3 font-mono text-white/60">
                <div className="flex items-center gap-2">
                  {row.rank <= 4 && <span className="w-1 h-6 bg-volt" />}
                  {row.rank > 4 && row.rank <= 6 && <span className="w-1 h-6 bg-[#FF9500]" />}
                  {row.rank}
                </div>
              </td>
              <td className="px-3 py-3">
                <div className="flex items-center gap-3">
                  <div className="w-7 h-7 bg-white/5 border border-white/10 flex items-center justify-center overflow-hidden">
                    {row.team.logo_url ? (
                      <img src={row.team.logo_url} alt={row.team.short} className="w-5 h-5 object-contain" />
                    ) : (
                      <span className="font-mono text-[10px]">{row.team.logo}</span>
                    )}
                  </div>
                  <span className="font-medium">{row.team.name}</span>
                  {row.group && (
                    <span className="text-[10px] uppercase tracking-[0.15em] text-white/40 ml-auto md:ml-0">
                      {row.group}
                    </span>
                  )}
                </div>
              </td>
              <td className="px-2 py-3 text-center font-mono tabular-nums text-white/70">{row.played}</td>
              <td className="px-2 py-3 text-center font-mono tabular-nums text-white/70">{row.won}</td>
              <td className="px-2 py-3 text-center font-mono tabular-nums text-white/70">{row.drawn}</td>
              <td className="px-2 py-3 text-center font-mono tabular-nums text-white/70">{row.lost}</td>
              <td className="px-2 py-3 text-center font-mono tabular-nums text-white/70 hidden md:table-cell">{row.gf}</td>
              <td className="px-2 py-3 text-center font-mono tabular-nums text-white/70 hidden md:table-cell">{row.ga}</td>
              <td className="px-3 py-3 text-center font-display text-xl text-volt tabular-nums">{row.points}</td>
              <td className="px-3 py-3 hidden lg:table-cell">
                <div className="flex items-center gap-1 justify-center">
                  {row.form.map((r, i) => <FormDot key={i} r={r} />)}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
